import { AfterViewInit, Component, inject, OnInit, ViewChild } from '@angular/core';
import { HttpService } from '../../http.service';
import { ActivatedRoute } from '@angular/router';
import { AdminReportDetailComponent } from '../admin-report-detail/admin-report-detail.component';
import { TableComponent } from '../table/table.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-admin-report',
  templateUrl: './admin-report.component.html',
  styleUrls: ['./admin-report.component.scss']
})
export class AdminReportComponent implements AfterViewInit {

  public summary:any = [];
  public today:any = new Date();
  public date = this.today.getFullYear() + "-" + ("0" + (this.today.getMonth() + 1)).slice(-2) + "-" + ("0" + this.today.getDate()).slice(-2);
  
  public is_loading = true;
  public is_init = false;
  public type:any;
  @ViewChild("history", { static: false }) wl: TableComponent;

  constructor(private http: HttpService, private activedRoute: ActivatedRoute, public ngbModal: NgbModal) { 
    this.today = this.today.getFullYear() + "-" + ("0" + (this.today.getMonth() + 1)).slice(-2) + "-" + ("0" + this.today.getDate()).slice(-2);

    this.activedRoute.params.subscribe((v) => {
      this.type = v.type;
      this.init()
    })
  }

  ngAfterViewInit(): void {
    this.is_init = true;
    this.init()
  }

  inputchange() {
    this.init();
  }

  async init() {
    
    if(!this.is_init) {
      return;
    }
    
    let t = new Date(this.date);

   let date = t.getFullYear() + "-" + ("0" + (t.getMonth() + 1)).slice(-2) + "-" + ("0" + (t.getDate())).slice(-2)
    const playerSummary = 
    { post: {url: "/admin/company/admin/summary", data: {date: date, type: this.type }},
      disabled_pagenat: false,
      show_sum: true,
      fields: [
        {label: 'No', type: 'index'}, 
        {label: 'Bank', type: 'string', key: 'name'}, 
        {label: 'Admin', type: 'string', key: 'username'}, 
        {label: 'Debit/In', type: 'price', key: 'debit', sum: true, border_left: true, border_right: true}, 
        {label: 'Credit/Out', type: 'price', key: 'credit', sum: true, border_left: true, border_right: true}, 
        {label: 'Create On', type: 'date', key: 'create_on'},
        {label: 'View', type: 'custom_link', func: this.openDialog}
      ]}

      if(this.type == "game") {
        playerSummary.fields = [
          {label: 'No', type: 'index'}, 
          {label: 'Game', type: 'string', key: 'name'}, 
          {label: 'Admin', type: 'string', key: 'username'}, 
          {label: 'Debit/In', type: 'price', key: 'debit', sum: true, border_left: true, border_right: true}, 
          {label: 'Credit/Out', type: 'price', key: 'credit', sum: true, border_left: true, border_right: true}, 
          {label: 'Create On', type: 'date', key: 'create_on'},
          {label: 'View', type: 'custom_link', func: this.openDialog}
        ]
      }

    this.wl.init(playerSummary);
  }

  openDialog(data:any, ngbModal:NgbModal): void {
    let modal = ngbModal.open(AdminReportDetailComponent, {size: "md"});
    modal.componentInstance.setIDS = data.ids
    modal.componentInstance.type = data.type;
  }

}
